/**
 * Enum for tax and contribution rules
 */
export enum TaxAndContributionsRulesEnum {
  NetSalary = 'NetSalary',
  SeafarerDeduction = 'SeafarerDeduction',
  SvalbardTaxAct = 'SvalbardTaxAct',
  NetSalaryForSeafarers = 'NetSalaryForSeafarers',
}
